module.exports = __webpack_public_path__ + "img/worldpos.666b9dcc.jpg";